import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue";
const _hoisted_1 = {
    ref: "akbheader",
    id: "akheader",
    class: "fixed-top d-md-none d-sm-none d-none d-lg-block"
};
const _hoisted_2 = { class: "container" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-md-4 d-sm-none d-md-block" };
const _hoisted_5 = { id: "logo" };
const _hoisted_6 = { href: "https://www.ak-berlin.de" };
const _hoisted_7 = { class: "col-md-8 p-0 aknav" };
const _hoisted_8 = { class: "navbar-expand-lg aknav-top p-0 pt-2" };
const _hoisted_9 = { class: "navbar-nav" };
const _hoisted_10 = { class: "nav-item" };
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("nav", { class: "navbar" }, [
    /*#__PURE__*/ _createElementVNode("div", {
        class: "collapse navbar-collapse",
        id: "akb-navbar"
    }, [
        /*#__PURE__*/ _createElementVNode("ul", { class: "nav navbar-nav" })
    ])
], -1);
const _hoisted_12 = {
    id: "akheadermobile",
    class: "ak-header-mobile fixed-top d-xl-none d-lg-none d-md-block d-sm-block d-block"
};
const _hoisted_13 = { class: "navbar navbar-light navbar-akb-mobile" };
const _hoisted_14 = { class: "navbar-brand logo-img-mobile" };
const _hoisted_15 = { class: "logo-img-mob" };
const _hoisted_16 = { href: "https://www.ak-berlin.de" };
const _hoisted_17 = { class: "navbar-button" };
const _hoisted_18 = { class: "center" };
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("span", null, null, -1);
const _hoisted_20 = /*#__PURE__*/ _createElementVNode("span", null, null, -1);
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("span", null, null, -1);
const _hoisted_22 = [
    _hoisted_19,
    _hoisted_20,
    _hoisted_21
];
const _hoisted_23 = {
    role: "main",
    class: "container akb-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_banner_panel = _resolveComponent("g-banner-panel");
    const _component_g_icon = _resolveComponent("g-icon");
    const _component_g_link = _resolveComponent("g-link");
    const _component_g_navview = _resolveComponent("g-navview");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("header", _hoisted_1, [
            _createVNode(_component_g_banner_panel),
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("a", _hoisted_6, [
                                _createVNode(_component_g_icon, {
                                    id: "logo-svg",
                                    src: "/themes/akb/akb-logo.svg"
                                })
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("nav", _hoisted_8, [
                            _createElementVNode("ul", _hoisted_9, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topMenuEntries, (menuItem) => {
                                    return (_openBlock(), _createElementBlock("li", _hoisted_10, [
                                        _createVNode(_component_g_link, {
                                            src: menuItem.actionCommand,
                                            target: menuItem.actionTarget,
                                            class: "nav-link"
                                        }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(menuItem.caption), 1)
                                            ]),
                                            _: 2
                                        }, 1032, ["src", "target"])
                                    ]));
                                }), 256))
                            ])
                        ]),
                        _hoisted_11
                    ])
                ])
            ])
        ], 512),
        _createElementVNode("header", _hoisted_12, [
            _createVNode(_component_g_banner_panel),
            _createElementVNode("nav", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("a", _hoisted_16, [
                            _createVNode(_component_g_icon, {
                                id: "logo-svg2",
                                src: "/themes/akb/akb-logo.svg"
                            })
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("button", {
                            onClick: _cache[0] || (_cache[0] =
                                //@ts-ignore
                                (...args) => (_ctx.onMobileNavToogle && _ctx.onMobileNavToogle(...args))),
                            class: _normalizeClass(['navbar-toggler navbar-toggler-right toggler-akb', _ctx.$host.pageMeta.mobileNavVisible ? '' : 'collapsed']),
                            type: "button"
                        }, _hoisted_22, 2)
                    ]),
                    _createVNode(_component_g_navview)
                ])
            ])
        ]),
        _createElementVNode("main", _hoisted_23, [
            _renderSlot(_ctx.$slots, "default")
        ])
    ], 64));
}
